// Engine identity, carried by every result (docs/ENGINE-GUIDE.md). GPL-3.0-or-later.
export const ENGINE = { name: "@dipfield/stereo", version: "1.1.0" } as const;
